import React, { Component } from 'react';
import { connect } from 'react-redux';
import { validarCodigoAcesso } from '../../ducks/Customer';
import { buscarFrontValidationAccessCode } from '../../ducks/Graphql';
import ReactTooltip from 'react-tooltip';
import { updateStateTheme } from '../../ducks/Theme';
import { ValidationService, StringService } from '../../services';
import { RouteKeys } from '../../constants';
import { ClipLoader } from 'react-spinners';
import { Loader, InputText } from '../../components';
import validation from './validation';
import qs from 'query-string';

import './styles.scss';

class ValidationAccessCode extends Component {
  constructor(props) {
    const params = qs.parse(props.location.search);
    const host = window.location.host;
    let urlRede = '';
    const hostArray = host.split('.');

    if (hostArray[0] === 'www') {
      urlRede = hostArray[1];
    } else {
      urlRede = hostArray[0].split(':')[0];
    }

    super(props);
    this.state = {
      chave: params.convite || '',
      cpf: params.cliente || '',
      urlRede: 'autocaptura-' + urlRede,
    };
  }

  async componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.ValidationAccessCode.title,
    );

    let items = await this.props.buscarFrontValidationAccessCode(
      this.state.urlRede,
    );
    if (items) {
      var dados = {
        fontePrimaria: items.fontePrimaria,
        fonteSecundaria: items.fonteSecundaria,
        backgroundPrimario: items.backgroundPrimario,
        backgroundSecundario: items.backgroundSecundario,
      };

      this.props.updateStateTheme({ prop: 'primario', value: dados });
    }
  }

  formIsValid = () => ValidationService.validate(this.state, validation);

  handleSubmit = async (event) => {
    event.preventDefault();

    if (
      !this.formIsValid() ||
      this.state.cpf === undefined ||
      this.state.cpf === '___.___.___-__'
    )
      return;

    const chave = this.state.chave;
    const cpf = this.state.cpf;
    this.props.validarCodigoAcesso({ chave, cpf });
  };

  handleChange = (event) => {
    const target = event.target;
    const name = target.name;

    this.setState({
      [name]: target.value,
    });
  };

  render() {
    const { loading, logo, acesso, banner, beneficios, rodape } =
      this.props.graphql;
    return loading ? (
      <div className="validation-access-code">
        <header>
          <div className="center">
            <img src={logo.url_image} alt={logo.alt_image} />
            <img
              src="img/validation-access-code/logo-credz.svg"
              alt="Logo Credz"
              height="25px"
              width="130px"
            />
          </div>
        </header>
        <div className="validation-container">
          <div className="container">
            <div className="content mobile-order-0">
              <div className="offer-highlight">
                <div className="offer-content">
                  <img src={acesso.url_image} alt={acesso.alt_image} />
                </div>
              </div>
            </div>
            <div className="content mobile-order-1">
              <div className="white-box">
                <div className="white-box-content">
                  <form id="frm" onSubmit={this.handleSubmit}>
                    <div className="title">
                      <p>Preencha seus dados</p>
                    </div>
                    <div className="input-form">
                      <InputText
                        id="chave"
                        name="chave"
                        value={this.state.chave}
                        onChange={this.handleChange}
                        placeholder="Digite seu código* "
                      />
                      <label className="label-small">
                        *Obtenha o código com a equipe da loja
                      </label>
                    </div>
                    <div className="input-form">
                      <InputText
                        type="tel"
                        value={this.state.cpf}
                        onChange={this.handleChange}
                        id="cpf"
                        name="cpf"
                        placeholder="Digite seu CPF"
                        mask="999.999.999-99"
                      />
                    </div>
                    <div className="button-container">
                      <input type="submit" value="Enviar" />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="separator"></div>
            <div className="content mobile-order-3">
              <div className="cards">
                <ul>
                  {beneficios &&
                    beneficios.map((b) => {
                      return (
                        <li key={b.id}>
                          <div className="content-box">
                            <div className="content-box-img">
                              <img src={b.url_image} alt={b.alt_image} />
                            </div>
                            <div className="content-box-text">
                              <p>{b.feature}</p>
                            </div>
                            {b.description && (
                              <div className="tooltip">
                                <img
                                  src="img/validation-access-code/icone-informacao.svg"
                                  alt="Ícone Informação"
                                  data-tip=""
                                  data-for={b.id}
                                />
                                <ReactTooltip place="bottom" id={b.id}>
                                  <div style={{ width: '200px' }}>
                                    <p>{b.description}</p>
                                  </div>
                                </ReactTooltip>
                              </div>
                            )}
                          </div>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
            <div className="content mobile-order-2">
              <div className="offer-detail">
                <img src={banner.url_image} alt={banner.alt_image} />
              </div>
            </div>
          </div>
        </div>
        <footer>
          <div>
            <img src={rodape.url_image} alt={rodape.alt_image} />
          </div>
        </footer>
        <Loader />
      </div>
    ) : (
      <div className="validation-access-code-error">
        <ClipLoader sizeUnit={'px'} size={100} color={'#CCCCCC'} />
        <p>
          Estamos carregando a tela inicial. Se você permanecer nessa tela por
          muito tempo, por favor acesse a página novamente em alguns minutos.
        </p>
      </div>
    );
  }
}

const mapStateToProps =
  (state) =>
    ({ graphql }) => {
      const chave = state.chave;
      const cpf = state.cpf;
      const urlRede = state.urlRede;

      return { chave, cpf, urlRede, graphql };
    };

export default connect(mapStateToProps, {
  validarCodigoAcesso,
  buscarFrontValidationAccessCode,
  updateStateTheme,
})(ValidationAccessCode);
